import sindreSorhusCamelize from "camelcase";
import sindreSorhusDecamelize from "decamelize";

import { containsNumber, containsUuid } from "@nephroflow/design-system/utils/string";
import { isArray, isPlainishObject } from "@nephroflow/design-system/utils/type-checks";

export function camelCase(str: string) {
  if (containsNumber(str) || containsUuid(str)) return str;

  function transform(str: string) {
    return sindreSorhusCamelize(str, { locale: false });
  }

  if (str.includes(".")) {
    return str.split(".").map(transform).join(".");
  }

  return transform(str);
}

export function camelCaseKeys<T extends Record<string, any> | any[]>(arg: T): T {
  return mapKeys(arg, camelCase) as T;
}

interface SnakeCaseOptions {
  separator?: string;
}

export function snakeCase(str: string, options?: SnakeCaseOptions) {
  if (containsNumber(str) || containsUuid(str)) return str;

  return sindreSorhusDecamelize(str, { separator: options?.separator || "_" });
}

export function snakeCaseKeys<T extends Record<string, any> | any[]>(arg: T, options?: SnakeCaseOptions): T {
  return mapKeys(arg, (key) => snakeCase(key, options)) as T;
}

function mapKeys<T>(arg: T, mapFn: (key: string) => string): T {
  if (isArray(arg)) {
    return arg.map((value) => mapKeys(value, mapFn)) as T;
  }

  if (isPlainishObject(arg)) {
    return Object.entries(arg).reduce(
      (acc, [key, value]) => {
        const newKey = mapFn(key);
        const newValue = mapKeys(value, mapFn);
        acc[newKey] = newValue;

        return acc;
      },
      {} as Record<string, any>,
    ) as T;
  }

  return arg;
}
